import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getPublicProfileUrl, isPersonalTrainer } from "../helpers/providers";

const useProviderProfileRedirect = (provider) => {
  const navigate = useNavigate();
  const location = useLocation();
  const providerType = isPersonalTrainer(provider) ? 'Personal Trainer' : 'Physical Therapist';
  const isPTPath = location.pathname.includes('/physical-therapists/');
  useEffect(() => {
    if (provider && providerType === 'Personal Trainer' && isPTPath) {
      navigate(getPublicProfileUrl(provider));
    }
    if (provider && providerType === 'Physical Therapist' && !isPTPath) {
      navigate(getPublicProfileUrl(provider));
    }
  }, [providerType, isPTPath, provider, navigate]);
};

export default useProviderProfileRedirect;